import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import Button from '../../../forms/Button';
import { voidCode } from '../../codes/Codes';

const SingleUseCodes = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.code.singleUse,
        isReport: true,
        headers: [
            {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Issued Date',
                propKey: 'issuedDate',
                type: 'dateTime'
            }, {
                label: 'Expiration Date',
                propKey: 'expirationDate',
                type: 'dateTime'
            }, {
                label: 'Used Date',
                propKey: 'usedDate',
                type: 'dateTime'
            }, {
                label: 'Name',
                propKey: 'washItemName',
                options: true
            }, {
                label: 'SKU',
                propKey: 'washItemSKU',
                options: true
            }, {
                label: 'ID',
                propKey: 'washItemId',
                options: true
            }, {
                label: 'Email',
                propKey: 'issuedToEmail',
            }, {
                label: 'Void',
                propKey: 'isVoided'
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.code}</td>
                <td>{shortHandDateTime(e.issuedDate)}</td>
                <td>{shortHandDateTime(e.expirationDate)}</td>
                <td>{e.usedDate ? shortHandDateTime(e.usedDate) : 'Unused'}</td>
                <td>{e.washItemName}</td>
                <td>{e.washItemSKU}</td>
                <td>{e.washItemId}</td>
                <td>{e.issuedToEmail}</td>
                <td>{!e.isVoided ? <Button onClick={() => voidCode(e.code).then(() => window.DateRange())}>Void</Button> : 'Voided'}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default SingleUseCodes;